module.exports = __webpack_public_path__ + "static/3.2-7f5ab09cd87b7253818aa1f273ef302e.jpg";